// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';
import _ from 'lodash';

import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';

import { UserDO } from 'wdna-components';
import { Tabs } from 'wdna-components/lib/tabs';
import { Navigation } from 'wdna-components/lib/navigation';
import ErrorBoundary from 'wdna-components/lib/errors/ErrorBoundary';
import GlobalLoader from 'wdna-components/lib/loaders/global/GlobalLoader';

import AppCrash from '../../routes/errors/containers/AppCrash';
import { config } from '../../config/config';

import Auth from '../../services/auth/Auth';

import Header from './Header';
import Footer from './Footer';

import { items as navigationItemsAdm } from '../../config/navigation/navigation.adm.json';
import { items as navigationItemsCli } from '../../config/navigation/navigation.cli.json';

const { maxMobileWidth } = config;

const MINIFIED_CLASS: string = 'minified';

type LayoutChild = {
  uid: string;
  value: React.ReactNode;
}

interface Props extends RouteComponentProps {
  user?: UserDO;
  children?: React.ReactNode[];
}

interface State {
  user?: UserDO;
}

class Layout extends React.PureComponent<Props, State> {
  private children: LayoutChild[];

  public constructor(props: Props) {
    super(props);

    this.children = this.props.children?.map((item: React.ReactNode): LayoutChild => {
      return { uid: _.uniqueId('layout-'), value: item };
    }) || [];
  }

  public componentDidMount(): void {
    setTimeout(() => {
      this.initialize();
    }, 0);
  }

  public className = (): string => {
    const user: UserDO = _.get(window.store.getState(), ['user', 'user']);
    const classUser: string = (user.type === 'adm') ? 'superadmin' : 'normalUser';

    return classUser;
  }

  public cancelLoader = (): void => {
    window.source.cancel('Operation canceled by the user.');
    window.source = window.CancelToken.source();
  };

  public initialize = (): void => {
    this.hideNavigation();
    this.refreshWindow();
  };

  public isMobile = (): boolean => {
    return ($(window)?.width() || 0) < maxMobileWidth;
  };

  public hideNavigation = (): void => {
    $('body').addClass(MINIFIED_CLASS);
  };

  public showNavigation = (): void => {
    $('body').removeClass(MINIFIED_CLASS);
  };

  public refreshWindow = (): void => {
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 100);
  };

  public render(): JSX.Element {
    const user: UserDO | null = Auth.getUser();
    if (!user) {
      return <Redirect to="/login" />;
    }

    const { type = 'cli' } = user;
    const navigationItems: any[] = (type === 'adm' ? navigationItemsAdm : navigationItemsCli);

    return (
      <div className={this.className()}>
        <GlobalLoader />
        <Header />
        <Navigation navigationItems={navigationItems} userRoles={user.role} />
        <div id="main" role="main">
          <ErrorBoundary errorMessage={<AppCrash />}>
            <Tabs key="layout-tab" />
            {this.children.map((child: LayoutChild) => {
              return <div key={child.uid}>{child.value}</div>;
            })}
          </ErrorBoundary>
        </div>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state: State, ownProps: Props): Props => {
  return {
    ...ownProps,
    user: state.user,
  };
};

export default withRouter(connect(mapStateToProps)(Layout));
